export default __webpack_public_path__ + "static/media/no-gps.2d7982cd.svg";